import { Component, EventEmitter, Input, Output, inject } from "@angular/core";
import { CommonModule } from "@angular/common";
import { AdminPageContainerComponent } from "../../components/ape-admin-page-container/ape-admin-page-container.component";
import { ApeAdminImpersonateSkeletonComponent } from "../../components/ape-admin-impersonate-skeleton/ape-admin-impersonate-skeleton.component";
import { ApeAdminImpersonateTableComponent } from "../../components/ape-admin-impersonate-table/ape-admin-impersonate-table.component";
import { TranslatePipe } from "../../pipe/translation.filter.pipe";
import { ImpersonifiableUserSummary } from "alloy-performance-engine-cl";
import { TRANSLATION_KEYS } from "../../constants/translations/translation-keys";
import { Router } from "@angular/router";
import { UrlCollection } from "../../constants/url-collection";

/**
 * Template per la gestione dell'impersonazione admin
 */
@Component({
  selector: "ape-admin-impersonate-template",
  standalone: true,
  imports: [
    CommonModule,
    AdminPageContainerComponent,
    ApeAdminImpersonateSkeletonComponent,
    ApeAdminImpersonateTableComponent,
    TranslatePipe
  ],
  templateUrl: "./admin-impersonate-template.component.html",
  host: { class: "flex flex-col flex-1 h-full min-h-0" }
})
export class ApeAdminImpersonateTemplateComponent {
  private router = inject(Router);

  /**
   * Chiavi di traduzione per type safety
   */
  readonly TRANSLATION_KEYS = TRANSLATION_KEYS;

  /**
   * Flag per indicare se mostrare il skeleton loader
   */
  @Input() showSkeletonLoader = false;

  /**
   * Lista degli utenti da mostrare
   */
  @Input() users: ImpersonifiableUserSummary[] = [];

  /**
   * Valore della ricerca
   */
  @Input() searchValue = "";

  /**
   * Flag di loading per i dati
   */
  @Input() loading = false;

  /**
   * Numero totale di elementi
   */
  @Input() totalItems = 0;

  /**
   * Pagina corrente per la paginazione
   */
  @Input() page = 1;

  /**
   * Dimensione pagina per la paginazione
   */
  @Input() pageSize = 10;

  /**
   * Evento emesso quando cambia il valore della ricerca
   */
  @Output() searchChange = new EventEmitter<string>();

  /**
   * Evento emesso quando si impersona un employee
   */
  @Output() impersonateEmployee = new EventEmitter<ImpersonifiableUserSummary>();

  /**
   * Evento emesso quando si impersona un manager
   */
  @Output() impersonateManager = new EventEmitter<ImpersonifiableUserSummary>();

  /**
   * Evento emesso quando si esegue una ricerca
   */
  @Output() search = new EventEmitter<{ page: number;
    pageSize: number;
    searchText?: string;
    isSearch?: boolean; }>();

  /**
   * Gestisce l'azione di back
   */
  onBackAction(): void {
    void this.router.navigate([UrlCollection.adminHomepage]);
  }

  /**
   * Gestisce il cambio della ricerca
   */
  onSearchChange(value: string): void {
    this.searchChange.emit(value);
  }

  /**
   * Gestisce l'esecuzione della ricerca
   */
  onSearch(params: { page: number;
    pageSize: number;
    searchText?: string;
    isSearch?: boolean; }): void {
    this.search.emit(params);
  }

  /**
   * Gestisce l'impersonazione dell'employee
   */
  onImpersonateEmployee(user: ImpersonifiableUserSummary): void {
    this.impersonateEmployee.emit(user);
  }

  /**
   * Gestisce l'impersonazione del manager
   */
  onImpersonateManager(user: ImpersonifiableUserSummary): void {
    this.impersonateManager.emit(user);
  }
}
